import React, { SyntheticEvent, useRef, useState } from "react";
import { useStaticQuery, graphql, Link } from "gatsby";
import _ from "lodash";
import FeaturePost from "../../components/feature-post/feature-post";
import {
  SidebarWrapper,
  SidebarWidget,
  WidgetTitle,
  TagItem
} from "./style";
import PodCast from "../../components/pod-cast/pod-cast";
import PodImg from "../../components/player/podImg";

type SidebarProps = {
  pod: string,
  podImg?: string
};

const Sidebar: React.FunctionComponent<SidebarProps> = ({ pod, podImg }) => {
  const audioRef = useRef<HTMLAudioElement>(null);

  const Data = useStaticQuery(graphql`
      query {
          allMarkdownRemark(
              sort: { fields: [frontmatter___date], order: DESC }
              limit: 5
          ) {
              edges {
                  node {
                      excerpt(pruneLength: 300)
                      fields {
                          slug
                      }
                      frontmatter {
                          date(formatString: "DD [<span>] MMM [</span>]")
                          title
                          pod
                          description
                          tags
                          cover {
                              childImageSharp {
                                  fluid(maxWidth: 90, maxHeight: 90, quality: 100) {
                                      ...GatsbyImageSharpFluid_withWebp
                                  }
                              }
                          }
                      }
                  }
              }
              group(field: frontmatter___tags) {
                  totalCount
                  fieldValue
              }
          }
      }
  `);

  const Posts = Data.allMarkdownRemark.edges;
  const Tags = Data.allMarkdownRemark.group;
  const [isPlaying, setIsPlaying] = useState(false);
  const [songInfo, setSongInfo] = useState<Record<string, any>>({
    currentTime: 0,
    duration: 0
  });
  const timeUpdateHandler = (e: SyntheticEvent) => {
    const {
      currentTime,
      duration
    }: { currentTime: number; duration: number } = e.target as HTMLMediaElement;
    setSongInfo({ ...songInfo, currentTime: currentTime, duration: duration });
  };
  return (
    <SidebarWrapper>
      {pod !== null && <SidebarWidget>
        <WidgetTitle>Pod Cast</WidgetTitle>
        <PodImg image={podImg}/>
        <PodCast setIsPlaying={setIsPlaying}  songInfo={songInfo} isPlaying={isPlaying} audioRef={audioRef} data={pod} />
        <audio
          ref={audioRef}
          src={pod}
          onTimeUpdate={timeUpdateHandler}
          onLoadedMetadata={timeUpdateHandler}
        />
      </SidebarWidget>}
      <SidebarWidget>
        <WidgetTitle>Latest Post</WidgetTitle>
        {Posts.map(({ node }: any) => {
          const title = node.frontmatter.title || node.fields.slug;
          // Random Placeholder Color
          const placeholderColors = [
            "#55efc4",
            "#81ecec",
            "#74b9ff",
            "#a29bfe",
            "#ffeaa7",
            "#fab1a0",
            "#e17055",
            "#0984e3",
            "#badc58",
            "#c7ecee"
          ];
          const setColor =
            placeholderColors[
              Math.floor(Math.random() * placeholderColors.length)
              ];

          return (
            <FeaturePost
              key={node.fields.slug}
              title={title}
              image={
                node.frontmatter.cover == null
                  ? null
                  : node.frontmatter.cover.childImageSharp.fluid
              }
              url={node.fields.slug}
              tags={node.frontmatter.tags}
              placeholderBG={setColor}
            />
          );
        })}
      </SidebarWidget>

      <SidebarWidget>
        <WidgetTitle>Tags</WidgetTitle>
        {Tags.map((tag: any) => (
          <TagItem key={tag.fieldValue}>
            <span>#</span>
            <Link to={`/tags/${_.kebabCase(tag.fieldValue)}/`}>
              {tag.fieldValue} <span>({tag.totalCount})</span>
            </Link>
          </TagItem>
        ))}
      </SidebarWidget>
    </SidebarWrapper>
  );
};

export default Sidebar;
